'use client';

import { c as _c } from "react/compiler-runtime";
function observePreview(video: HTMLVideoElement, src: string) {
  let visible = false;
  video.playbackRate = 0.65;
  function sync() {
    if (visible && !document.hidden) {
      if (!video.getAttribute('src')) video.src = src;
      void video.play().catch(() => {});
    } else video.pause();
  }
  const observer = new IntersectionObserver(([entry]) => {
    visible = entry?.isIntersecting ?? false;
    sync();
  });
  observer.observe(video);
  document.addEventListener('visibilitychange', sync);
  return () => {
    observer.disconnect();
    document.removeEventListener('visibilitychange', sync);
    video.pause();
  };
}
export function PreviewLoop(t0) {
  const $ = _c(6);
  const {
    src,
    poster
  } = t0;
  if (!src || !poster) {
    return null;
  }
  let t1;
  if ($[0] !== src) {
    t1 = video => video ? observePreview(video, src) : undefined;
    $[0] = src;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== poster || $[3] !== src || $[4] !== t1) {
    t2 = <video key={src} className="lookbook-preview-loop" ref={t1} poster={poster} muted={true} loop={true} playsInline={true} preload="none" draggable={false} aria-hidden="true" />;
    $[2] = poster;
    $[3] = src;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}